import React from "react"

type HeadingLevel = "h2" | "h3" | "h4" | "h5" | "h6"

interface Props {
  children: React.ReactNode
  color?: string
  as?: HeadingLevel
}

const CardHeading = ({
  children,
  color = "#1E3A5F",
  as: Tag = "h3"
}: Props) => {
  const textSizeClass =
    Tag === "h4" || Tag === "h5" || Tag === "h6" ? "text-[24px]" : "text-[27px]"

  return (
    <Tag
      className={`${textSizeClass} font-semibold leading-tight`}
      style={{ color }}
    >
      {children}
    </Tag>
  )
}

export default CardHeading
